import { put, takeLatest } from 'redux-saga/effects';
import { cloudSearchSettingsClient } from '../app/runtime/cloudSearchSettingsClient';
import {
  FETCH_V2_CONFIG,
  FETCH_V2_CONFIG_SUCCESS,
  FETCH_V2_CONFIG_FAILURE,
  ACTIVATE_PRODUCTION,
  ACTIVATE_PRODUCTION_SUCCESS,
  ACTIVATE_PRODUCTION_FAILURE,
} from '../slices/settingsV2Slice';

export function* fetchV2Config({ payload }) {
  try {
    const { shopId, mode } = payload;
    const config = yield cloudSearchSettingsClient.loadSearchExperienceConfig(shopId, mode);

    yield put({
      type: FETCH_V2_CONFIG_SUCCESS,
      payload: { mode, data: config },
    });
  } catch (error) {
    yield put({
      type: FETCH_V2_CONFIG_FAILURE,
      payload: error.message || 'Failed to fetch config',
    });
  }
}

export function* activateProduction({ payload }) {
  try {
    const { shopId } = payload;
    const result = yield cloudSearchSettingsClient.copySearchExperienceToProduction(shopId);

    yield put({
      type: ACTIVATE_PRODUCTION_SUCCESS,
      payload: result.config,
    });
  } catch (error) {
    yield put({
      type: ACTIVATE_PRODUCTION_FAILURE,
      payload: error.message || 'Failed to activate production',
    });
  }
}

export default function* settingsV2Saga() {
  yield takeLatest(FETCH_V2_CONFIG, fetchV2Config);
  yield takeLatest(ACTIVATE_PRODUCTION, activateProduction);
}
